import React from 'react';

const DateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 15 16"
  >
    <path d="M13.734 2.06H12.15V.908a.45.45 0 00-.45-.45H9.828a.45.45 0 00-.45.45V2.06H4.806V.908a.45.45 0 00-.45-.45H2.484a.45.45 0 00-.45.45V2.06H.45a.45.45 0 00-.45.45v12.582a.45.45 0 00.45.45h13.284a.45.45 0 00.45-.45V2.51a.45.45 0 00-.45-.45zm-3.456-.702h.99v1.818h-.99V1.358zm-7.344 0h.99v1.818h-.99V1.358zM6.66 12.122a.45.45 0 01-.63 0l-1.908-1.854.63-.648 1.602 1.548L9.45 8.27l.612.648-3.402 3.204zm6.624-6.39H.9V2.96h1.134v.666a.45.45 0 00.45.45h1.872a.45.45 0 00.45-.45V2.96h4.572v.666a.45.45 0 00.45.45H11.7a.45.45 0 00.45-.45V2.96h1.134v2.772z" />
  </svg>
);

export default DateIcon;
